import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API,
    withCredentials: true,
});

client.interceptors.request.use((config) => {
    const token = localStorage.getItem("sj_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export default client;

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function formatINR(n) {
    if (n == null || isNaN(n)) return "Price on Request";
    return "₹" + Number(n).toLocaleString("en-IN");
}

export function whatsappLink(number, message) {
    const cleaned = (number || "+919999999999").replace(/[^\d+]/g, "");
    return `https://wa.me/${cleaned.replace("+", "")}?text=${encodeURIComponent(message || "")}`;
}
